import { spaceClient } from './client';

export const getLocaleByKey = (key) =>
  spaceClient.get(`/localizations/${key}`, { withCredentials: true }).then((r) => r.data);

export const getAllLocalizations = () =>
  spaceClient.get('/localizations/', { withCredentials: true }).then((r) => r.data);

export const createLocaleKey = (payload) =>
  spaceClient.post('/localizations/', payload, { withCredentials: true });

export const updateLocaleByKey = (key, payload) =>
  spaceClient.put(`/localizations/${key}`, payload, { withCredentials: true });
